import styled from "@emotion/styled";

export const USiteWrapper = styled("div")(
  ({ theme: { designTokens: DT } }) => `
    background: ${DT.T_CARD_COLOR_BG_DEFAULT};
    .pwd-rule {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .pwd-rule.pwd-rule--1 {
        color: ${DT.T_COLOR_TEXT_ERROR};
    }
    .pwd-rule.pwd-rule--2 {
        color: ${DT.T_COLOR_TEXT_ERROR};
    }
    .pwd-rule.pwd-rule-1 {
        color: ${DT.T_COLOR_TEXT_ERROR};
    }
    .pwd-rule.pwd-rule-2 {
        color: ${DT.T_COLOR_TEXT_WARNING};
    }
    .pwd-rule.pwd-rule-3 {
        color: ${DT.T_COLOR_TEXT_WARNING};
    }
    .pwd-rule.pwd-rule-4 {
        color: ${DT.T_COLOR_TEXT_SUCCESS};
    }
    .pws-strength.pwd-strength-1 {
        border-color: ${DT.T_COLOR_LINE_ERROR_DARK};
    }
    .pws-strength.pwd-strength-2 {
        border-color: ${DT.T_COLOR_LINE_WARNING_DARK};
    }
    .pws-strength.pwd-strength-3 {
        border-color: ${DT.T_COLOR_LINE_WARNING_DARK};
    }
    .pws-strength.pwd-strength-4 {
        border-color: ${DT.T_COLOR_LINE_SUCCESS_DARK};
    }
    .u-header {
        border-bottom: 1px solid ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
    }
    .u-header .u-header-right .t2s {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .u-header .u-header-right a {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .register-form-wrapper .register-form-left {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .register-form-wrapper .register-form-right {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .normal-text {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .forget-btn {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .phone-code-counter {
        border-left: solid 1px ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
    }
    .active-account-title {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .active-account-desc {
        color: ${(props) => props.theme.designTokens.T_COLOR_TEXT_DEFAULT_LIGHT}
    }
    .oauth-wrapper .desc.google {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .oauth-wrapper .desc.wx {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .oauth-wrapper .title {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .verify-img-wrapper {
        border: 1px solid ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
    }
    .copyright {
        color: ${DT.T_COLOR_TEXT_REMARK_DARK};

    }
    .title-seperator {
        border-bottom: 1px solid ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
    }
    .text-default-dark {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .style-obj {
        border: 1px solid ${DT.T_COLOR_LINE_DEFAULT_DARK};
        outline-width: 2px;
        background: ${DT.T_INPUT_COLOR_BG_DEFAULT};
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .style-err {
        border: 1px solid ${DT.T_COLOR_LINE_ERROR_DARK};
        background: ${DT.T_INPUT_COLOR_BG_DEFAULT};
        outline: none;
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .icon__dianpuhezi_close {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .title {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .guide-wrapper .title {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .guide-wrapper .content {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .guide-wrapper .content .coupon {
        color: ${DT.T_COLOR_TEXT_PRIMARY_HOVER};
    }
    .guide-wrapper .close-icon {
        color: ${DT.T_BUTTON_PRIMARY_COLOR_TEXT_DEFAULT};
    }
    .active-result-icon {
        color: ${DT.T_BUTTON_PRIMARY_COLOR_TEXT_DEFAULT};
    }
    .active-result-icon.success {
        background-color: ${DT.T_COLOR_LINE_SUCCESS_DARK};
    }
    .active-result-icon.fail {
        background-color: ${DT.T_COLOR_LINE_ERROR_DARK};
    }
    .subaccountauth-text,
    .subaccountauth-right-info-tips {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .subaccountauth-right {
        border-left: 1px solid ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
    }
    .subaccountauth-left-tip {
        background-color: ${DT.T_COLOR_BG_NOTICE_LIGHT};
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .subaccountauth-right-qrcode {
        border: 1px solid ${DT.T_COLOR_LINE_DEFAULT_DARK};
    }
    .subaccountauth-right-help-img {
        background-color: ${DT.T_COLOR_BG_MENU};
    }
    .subaccountauth-left-qrimg {
        background-color: ${DT.T_COLOR_BG_NOTICE_LIGHT};
    }
    .subaccountauth-right-code-error {
        color: ${DT.T_COLOR_TEXT_ERROR};
    }

    .register-form-top .register-form-line {
        background-color: ${DT.T_COLOR_TEXT_PRIMARY_HOVER};
    }
    .register-form-top .register-form-right:hover,
    .u-header-right .t2s span:hover,
    .u-header-right a:hover,
    .u-blue,
    .register-form-wrapper .forget-btn:hover, .active {
        color: ${(props) =>
          props.theme.designTokens.T_COLOR_TEXT_PRIMARY_HOVER};
    }
    .uc-select {
        color: ${DT.T_COLOR_TEXT_DEFAULT_DARK};
    }
    .card {
        background: ${DT.T_CARD_COLOR_BG_DEFAULT};
    }
    .disabled {
        color: ${(props) => props.theme.designTokens.T_COLOR_TEXT_REMARK_LIGHT};
    }
    .account-rgap {
        border-right: 1px solid ${DT.T_COLOR_LINE_PRIMARY_LIGHT};
    }
    .QR-img-border {
        border: 1px solid ${DT.T_COLOR_LINE_DEFAULT_LIGHT};
    }
    .primary-color {
        color: ${DT.T_COLOR_BG_PRIMARY_1};
    }
    .error-color {
        color: ${DT.T_COLOR_BG_ERROR_DARK};
    }
    .success-color {
        color: ${DT.T_COLOR_BG_SUCCESS_DARK};
    }
    .dark-text {
        color:  ${DT.T_COLOR_BRAND_BLACK};
    }
    ,remark-text-color {
        color: ${DT.T_COLOR_TEXT_DEFAULT_LIGHT};
    }
    .u-blue, a.u-blue{
        color: ${DT.T_COLOR_TEXT_PRIMARY_DEFAULT};
    }
    .uc-select:hover {
        color: ${DT.T_COLOR_TEXT_PRIMARY_HOVER};
    }
    .active-countdown {
        color: ${DT.T_COLOR_TEXT_PRIMARY_DEFAULT};
    }
`
);
export const LocationIcon = styled("i")(
  ({ theme: { designTokens: DT } }) => `
    vertical-align: baseline;
    padding-right: 4px;
    font-size: 14px;
    color: ${DT.T_COLOR_TEXT_PRIMARY_DEFAULT};
    `
);



// WEBPACK FOOTER //
// ./src/common/stylecomponent.js